import * as React from "react";
import {Option} from "ts-option";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import Loading from "../../ui/loading/Loading";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import DictionarySortableItemsTable from "../common/DictionarySortableItemsTable";
import Routes from "../../../navigation/route/Route";
import {RouteComponentProps, withRouter} from "react-router";
import {Dispatch} from "redux";
import {fetchActivityTemplates, fetchJobActivityTemplates} from "../../../store/action/survey/survey";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface IDispatchProps {
	fetchActivityTemplates: () => void
	fetchJobActivityTemplates: () => void
}

interface IComponentProps {
	/**
	 * All activity templates
	 */
	activityTemplates: Option<DictionaryItem[]>;
	/**
	 * All job activity templates
	 */
	jobActivityTemplates: Option<DictionaryItem[]>;
}

type Props = IComponentProps & IDispatchProps & RouteComponentProps<{}>

class ActivityTemplateList extends React.PureComponent<Props, {}> {
	componentDidMount() {
		this.props.fetchActivityTemplates();
		this.props.fetchJobActivityTemplates();
	}

	render() {
		return (
			<div>
				<PageHeaderView header={"Activity templates"}/>
				<PageContentView>
					<Loading isLoading={this.props.activityTemplates.isEmpty}>
						<DictionarySortableItemsTable items={this.props.activityTemplates.getOrElse([])}
													  onRowClick={(activity) => this.props.history.push(
														  Routes.ActivityTemplateTasks(activity.id))}
													  onOrderChange={() => { }}
													  isDropDisabled={true}/>
					</Loading>
				</PageContentView>

				<PageHeaderView header={"Job activity templates"}/>
				<PageContentView>
					<Loading isLoading={this.props.jobActivityTemplates.isEmpty}>
						<DictionarySortableItemsTable items={this.props.jobActivityTemplates.getOrElse([])}
													  onRowClick={(activity) => this.props.history.push(
														  Routes.JobActivityTemplateTasks(activity.id))}
													  onOrderChange={() => { }}
													  isDropDisabled={true}/>
					</Loading>
				</PageContentView>
			</div>
		)
	}
}

function mapStateToProps(state: RootState) {
	return {
		activityTemplates: state.survey.activityTemplates,
		jobActivityTemplates: state.survey.jobActivityTemplates
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchActivityTemplates: () => dispatch(
			fetchActivityTemplates(() => {}, (err) => notifyBugsnagAndShowToast(err, "Fetch activity templates"))),
		fetchJobActivityTemplates: () => dispatch(
			fetchJobActivityTemplates(() => {}, (err) => notifyBugsnagAndShowToast(err, "Fetch job activity templates")))
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivityTemplateList))